import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import RestrictionModal from '@/components/RestrictionModal';
import useLearningRestrictions from '@/hooks/useLearningRestrictions';
import useCourseAccess from '@/hooks/useCourseAccess';

export default function QuizMenuPage() {
    const navigate = useNavigate();
    const { settings, loading: restrictionsLoading } = useLearningRestrictions();
    const { hasEligibleCourse, loading: courseLoading } = useCourseAccess();

    useEffect(() => {
        if (!courseLoading && !hasEligibleCourse) {
            alert('お申込みのコースではご利用いただけません。');
            navigate('/learning');
        }
    }, [courseLoading, hasEligibleCourse, navigate]);

    if (restrictionsLoading || courseLoading) {
        return <div className="min-h-screen flex items-center justify-center">制限設定を確認中です...</div>;
    }

    if (!hasEligibleCourse) {
        return null;
    }

    if (!settings.quizEnabled) {
        return (
            <div className="min-h-screen bg-[#F5F5F5]"> 
                <RestrictionModal
                    open
                    message={settings.message}
                    actionLabel="学習メニューへ戻る"
                    onAction={() => navigate('/learning')}
                />
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-[#F5F5F5]">
            <header className="bg-white sticky top-0 z-10 border-b border-gray-100 shadow-sm">
                <div className="max-w-md mx-auto px-4 h-14 flex items-center">
                    <button
                        onClick={() => navigate('/learning')}
                        className="w-10 h-10 flex items-center justify-center -ml-2 text-gray-400 hover:text-gray-600 transition-colors"
                    >
                        <i className="ri-arrow-left-s-line text-2xl"></i>
                    </button>
                    <h1 className="flex-1 text-center font-bold text-gray-800 pr-8 text-base">
                        クイズメニュー
                    </h1>
                </div>
            </header>

            <div className="max-w-md mx-auto px-4 py-6 space-y-4">
                <button
                    onClick={() =>
                        settings.quizEnabled && hasEligibleCourse ? navigate('/quiz/play') : undefined
                    }
                    className="w-full py-4 text-lg font-bold text-white bg-blue-600 rounded-2xl hover:bg-blue-700 transition shadow-sm flex items-center justify-center gap-2"
                >
                    <i className="ri-play-circle-line text-xl"></i>
                    クイズを始める
                </button>

                <button
                    onClick={() =>
                        settings.quizEnabled && hasEligibleCourse ? navigate('/quiz/history') : undefined
                    }
                    className="w-full py-4 text-lg font-bold text-gray-700 bg-white rounded-2xl hover:bg-gray-50 transition shadow-sm flex items-center justify-center gap-2"
                >
                    <i className="ri-history-line text-xl"></i>
                    履歴を見る
                </button>

                <div className="pt-4">
                    <button
                        onClick={() => navigate('/home')}
                        className="w-full py-3 text-gray-500 bg-transparent hover:text-gray-700 transition font-medium"
                    >
                        ホームに戻る
                    </button>
                </div>
            </div>

        </div>
    );
}
